export enum InvitationType {
  TENANT = 'Tenant',
  SERVICE = 'Service'
}

/** appInvite/{estateId}/{id} */
export interface AppInviteData {
  /** residentId or subcontractorId  */
  id: string;
  createDate: number;
  phoneNumber: string;
  /** sms queue object id */
  queueRefId: string;
}

